export const lightCellAndFontColors = [
    { fontColor: '#00aeef', cellColor: '', var: 'condition-cell-font-1' },
    { fontColor: '#72a13b', cellColor: '', var: 'condition-cell-font-2' },
    { fontColor: '#c30b1e', cellColor: '', var: 'condition-cell-font-3' },
    { fontColor: '#07506d', cellColor: '', var: 'condition-cell-font-4' },
    { fontColor: '#f5ad1c', cellColor: '', var: 'condition-cell-font-5' },
    { fontColor: '#c1c0c2', cellColor: '', var: 'condition-cell-font-6' },
    { fontColor: '#58595b', cellColor: '', var: 'condition-cell-font-7' },
    { fontColor: '#000', cellColor: '', var: 'condition-cell-font-8' },
    { fontColor: '#000', cellColor: '#e5f5fd', var: 'condition-cell-font-9' },
    { fontColor: '#fff', cellColor: '#00aeef', var: 'condition-cell-font-10' },
    { fontColor: '#fff', cellColor: '#07506d', var: 'condition-cell-font-11' },
    { fontColor: '#000', cellColor: '#f1f2f2', var: 'condition-cell-font-12' },
    { fontColor: '#000', cellColor: '#dfe1e6', var: 'condition-cell-font-13' },
    { fontColor: '#000', cellColor: '#b7bcc6', var: 'condition-cell-font-14' },
    { fontColor: '#fff', cellColor: '#7e8c95', var: 'condition-cell-font-15' },
    { fontColor: '#fff', cellColor: '#5b676e', var: 'condition-cell-font-16' },
    { fontColor: '#000', cellColor: '#fde1de', var: 'condition-cell-font-17' },
    { fontColor: '#000', cellColor: '#f47d7f', var: 'condition-cell-font-18' },
    { fontColor: '#fff', cellColor: '#c30b1e', var: 'condition-cell-font-19' },
    { fontColor: '#fff', cellColor: '#8dc449', var: 'condition-cell-font-20' },
    { fontColor: '#000', cellColor: '#c2dc9d', var: 'condition-cell-font-21' },
    { fontColor: '#000', cellColor: '#ecf4e1', var: 'condition-cell-font-22' },
    { fontColor: '#000', cellColor: '#ffd050', var: 'condition-cell-font-23' },
];

export const darkCellAndFontColors = [
    { fontColor: '#13aee5', cellColor: '', var: 'condition-cell-font-1' },
    { fontColor: '#72a13b', cellColor: '', var: 'condition-cell-font-2' },
    { fontColor: '#ea3a39', cellColor: '', var: 'condition-cell-font-3' },
    { fontColor: '#07506d', cellColor: '', var: 'condition-cell-font-4' },
    { fontColor: '#f9be14', cellColor: '', var: 'condition-cell-font-5' },
    { fontColor: 'rgba(250,251,255,0.25)', cellColor: '', var: 'condition-cell-font-6' },
    { fontColor: 'rgba(250,251,255,0.65)', cellColor: '', var: 'condition-cell-font-7' },
    { fontColor: '#fff', cellColor: '', var: 'condition-cell-font-8' },
    { fontColor: '#fff', cellColor: '#143a49', var: 'condition-cell-font-9' },
    { fontColor: '#fff', cellColor: '#1485b6', var: 'condition-cell-font-10' },
    { fontColor: '#000', cellColor: '#95c1dd', var: 'condition-cell-font-11' },
    { fontColor: '#fff', cellColor: 'rgba(250,251,255,0.08)', var: 'condition-cell-font-12' },
    { fontColor: '#fff', cellColor: 'rgba(250,251,255,0.15)', var: 'condition-cell-font-13' },
    { fontColor: '#fff', cellColor: 'rgba(250,251,255,0.30)', var: 'condition-cell-font-14' },
    { fontColor: '#000', cellColor: 'rgba(250,251,255,0.50)', var: 'condition-cell-font-15' },
    { fontColor: '#000', cellColor: 'rgba(250,251,255,0.70)', var: 'condition-cell-font-16' },
    { fontColor: '#fff', cellColor: 'rgba(195,11,30,0.30)', var: 'condition-cell-font-17' },
    { fontColor: '#fff', cellColor: 'rgba(195,11,30,0.68)', var: 'condition-cell-font-18' },
    { fontColor: '#fff', cellColor: 'rgba(195,11,30,1.00)', var: 'condition-cell-font-19' },
    { fontColor: '#fff', cellColor: 'rgba(141,196,73,0.89)', var: 'condition-cell-font-20' },
    { fontColor: '#fff', cellColor: 'rgba(141,196,73,0.50)', var: 'condition-cell-font-21' },
    { fontColor: '#fff', cellColor: 'rgba(141,196,73,0.20)', var: 'condition-cell-font-22' },
    { fontColor: '#000', cellColor: '#f9be14', var: 'condition-cell-font-23' },
];
